module.exports = __webpack_public_path__ + "media/little-mac.631499b0.wav";